import { createFactorSensitivityContributorsQuery } from "./sensitivities"
import { createDrilldownContributorsQuery } from "./drilldown-helpers"
import { createDrilldownBaseGatherers, type DrilldownBaseGathererOptions } from "./drilldown-base"
import { FACTOR_SENSITIVITY_TYPES, getMetricFromFactorSensitivityType } from "helpers/factorSensitivity"
import type { ContributorsQueryOptions } from "./contributors-query-types"

type FactorSensitivityType = typeof FACTOR_SENSITIVITY_TYPES[keyof typeof FACTOR_SENSITIVITY_TYPES]

export function createDrilldownFactorSensitivityContributorsQuery({
  selectedFactor,
  ...options
}: ContributorsQueryOptions) {
  const factorIds = selectedFactor ? [selectedFactor] : []
  return createDrilldownContributorsQuery(createFactorSensitivityContributorsQuery, factorIds, options)
}

export function createFactorSensitivityDrilldownGatherers({
  endDate,
  startDate,
  selectedFactor,
  selectedCategory,
  classifications,
  factorSensitivityType,
  instrumentSuffix = "",
  ...coreOptions
}: DrilldownBaseGathererOptions & {
  selectedFactor?: string
  selectedCategory?: string
  factorSensitivityType: FactorSensitivityType
}) {
  const baseGatherers = createDrilldownBaseGatherers({
    ...coreOptions,
    endDate,
    startDate,
    classifications,
    instrumentSuffix,
  })
  const sensitivityGatherer = createDrilldownFactorSensitivityContributorsQuery({
    ...coreOptions,
    prefix: `${getMetricFromFactorSensitivityType(factorSensitivityType)}${instrumentSuffix}`,
    factorSensitivityType,
    from: startDate,
    to: endDate,
    selectedFactor,
    selectedCategory,
  })
  return [...baseGatherers, sensitivityGatherer]
}
